import { Component, Input, OnChanges } from '@angular/core';
import { FormControl, ReactiveFormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { Validators, AbstractControl, ValidationErrors } from '@angular/forms';
import { DigitOnlyDirective } from 'src/app/directives/digit-only.directive';

@Component({
  selector: 'app-reactive-text-input',
  standalone: true,
  imports: [ReactiveFormsModule, CommonModule, DigitOnlyDirective],
  templateUrl: './reactive-text-input.component.html',
  styleUrls: ['./reactive-text-input.component.scss'],
})
export class ReactiveTextInputComponent implements OnChanges {
  @Input() label: string = '';
  @Input() type: string = 'text';
  @Input() id: string = '';
  @Input() control: FormControl = new FormControl();
  @Input() placeholder: string = '';
  @Input() required: boolean = false;
  @Input() errorMessage: string = 'Something is wrong!';
  @Input() reference: string = '';
  @Input() minNum: number = 10;
  @Input() maxNum: number = 12;
  @Input() inputmode: string | null = null;

  ngOnChanges(): void {
    const validators = [];
    if (this.required) {
      validators.push(Validators.required);
    }
    if (this.reference === 'bank-number') {
      validators.push(this.bankNumberValidator.bind(this));
    }
    this.control.setValidators(validators);
    this.control.updateValueAndValidity(); // Trigger validation
  }

  bankNumberValidator(control: AbstractControl): ValidationErrors | null {
    const value = control.value;
    const regex = new RegExp(`^\\d{${this.minNum},${this.maxNum}}$`);
    const valid = regex.test(value);
    return valid ? null : { bankNumberInvalid: true };
  }
}
